import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {BrazeManager} from 'src/app/data/manager/braze/braze.manager';
import {CarouselsManager} from 'src/app/data/manager/cms/carousels.manager';
import {ConfigurationManager} from 'src/app/data/manager/configuration/configuration.manager';
import {CustomerManager} from '../../data/manager/customer/customer/customer.manager';
import {CartManager} from '../../data/manager/cart/cart.manager';
import {LocalStorageManager} from 'src/app/data/manager/local-storage/local-storage.manager';

@Injectable({
  providedIn: 'root',
})
export class RecommendedVm {
  constructor(private brazeManager: BrazeManager,
              private cartManager: CartManager,
              private customerManager: CustomerManager,
              private carrouselManager: CarouselsManager,
              private configurationManager: ConfigurationManager,
              private lsm: LocalStorageManager) { }

  hasCustomer() {
    return this.customerManager.hasCustomer();
  }

  getOrigin(property): Observable<any> {
    return this.configurationManager.getOrigin(property);
  }

  getSuggested(): Observable<any> {
    return this.carrouselManager.getSuggested()
      .pipe(
        switchMap(res => this.getOrigin('ADDED_FROM_SUGGESTED_HOME')
            .pipe(
              map(origin => (res.map(i => { i.rsList = origin || 'Sugeridos carrusel'; i.origin = origin; return i; }))),
            )),
      );
  }

  getAdvertisedItems(): Observable<any> {
    return this.cartManager.getAdvertisedItems();
  }

  getlastItemViewed(id): Observable<any> {
    return this.brazeManager.lastItemViewed(id);
  }
  
  getBrazeId() {
    return this.lsm.get('customer')?.analyticsUUID;
  }

}
